import { render, staticRenderFns } from "./AtendimentoListRoute.vue?vue&type=template&id=5e5ca676&scoped=true"
import script from "./AtendimentoListRoute.vue?vue&type=script&lang=js"
export * from "./AtendimentoListRoute.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoListRoute.vue?vue&type=style&index=0&id=5e5ca676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5ca676",
  null
  
)

export default component.exports